import { Link } from "react-router-dom";
import { hotTags, hotTopics } from "@/mocks/community";

function rankStyle(rank: number) {
  if (rank === 1) return "bg-primary-500 text-background-50";
  if (rank === 2) return "bg-primary-400 text-background-50";
  if (rank === 3) return "bg-accent-500 text-primary-950";
  return "bg-background-200 text-foreground-700";
}

export default function HotSidebar() {
  const top = hotTopics.slice(0, 6);

  return (
    <aside className="flex flex-col gap-6">
      <section className="rounded-xl border border-background-200 bg-background-50 p-5">
        <div className="flex items-center justify-between">
          <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
            板块热榜
          </h3>
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <span className="h-2 w-2 animate-pulse rounded-full bg-primary-500" aria-hidden="true" />
            实时
          </span>
        </div>
        <ol className="mt-4 space-y-1">
          {top.map((topic) => (
            <li key={topic.rank}>
              <Link
                to={`/post/${topic.postId}`}
                className="group flex items-start gap-3 rounded-lg px-2 py-2.5 transition-colors hover:bg-primary-50"
              >
                <span
                  className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${rankStyle(
                    topic.rank,
                  )}`}
                >
                  {topic.rank}
                </span>
                <span className="min-w-0">
                  <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                    {topic.title}
                  </span>
                  <span className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-fire-line" aria-hidden="true" />
                      {(topic.heat / 10000).toFixed(1)}万
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-chat-3-line" aria-hidden="true" />
                      {topic.replyCount}
                    </span>
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
        <Link
          to="/topics"
          className="mt-3 flex items-center justify-center gap-1 rounded-md border border-background-300 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          查看完整话题榜
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </section>

      <section className="rounded-xl border border-background-200 bg-background-100 p-5">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-price-tag-3-line text-secondary-500" aria-hidden="true" />
          热门标签
        </h3>
        <div className="mt-4 flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <Link
              key={tag}
              to={`/topics?q=${encodeURIComponent(tag)}`}
              className="rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-600"
            >
              #{tag}
            </Link>
          ))}
        </div>
      </section>
    </aside>
  );
}